import type { FileReleaseNote } from './releaseNotes'

const releaseNotesData: FileReleaseNote[] = [
  {
    'source': 'Front',
    'version': '1.73.0',
    'date': '2026-09-11 12:00',
    'changes': {
      'fr': {
        'features': [
          'Gestion du réseau WiFi'
        ],
        'bugfixes': []
      },
      'en': {
        'features': [
          'Wi-Fi network management'
        ],
        'bugfixes': []
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.72.6',
    'date': '2026-09-10 17:06',
    'changes': {
      'fr': {
        'features': [
          'TV & Chromecast : filtre par statut.',
          'Supervision : mémorisation du mode d’affichage.',
          'Codes : téléphone dans la fiche détail.'
        ],
        'bugfixes': [
          'Supervision : correction des boutons d’équipements.',
          'Supervision : correction de l’écran vide.',
          'Exports : infobulles manquantes ajoutées.'
        ]
      },
      'en': {
        'features': [
          'TV & Chromecast: add a status filter.',
          'Monitoring: remember the display mode.',
          'Codes: show the phone in the detail card.'
        ],
        'bugfixes': [
          'Monitoring: fix equipment type buttons.',
          'Monitoring: fix the empty state.',
          'Exports: add missing tooltips.'
        ]
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.72.5',
    'date': '2026-09-10 09:54',
    'changes': {
      'fr': {
        'features': [
          'Stats WiFi : filtres « Mois dernier » et « 3 derniers mois ».',
          'Stats WiFi : consommation moyenne par appareil dans l’export.'
        ],
        'bugfixes': [
          'Stats WiFi : correction de la sélection globale des SSID.'
        ]
      },
      'en': {
        'features': [
          'WiFi statistics: Last month and Last 3 months filters.',
          'WiFi statistics: average consumption per device in exports.'
        ],
        'bugfixes': [
          'WiFi statistics: fix global SSID selection.'
        ]
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.72.4',
    'date': '2026-09-07 15:56',
    'changes': {
      'fr': {
        'features': [],
        'bugfixes': [
          'WiFi privé : actions en masse fixées en bas de l’écran.',
          'WiFi privé : correction du glisser-déposer à l’import.',
          'WiFi privé : erreur si trop de clés sont importées.',
          'WiFi événementiel : correction des fuseaux IANA.'
        ]
      },
      'en': {
        'features': [],
        'bugfixes': [
          'Private WiFi: pin bulk actions to the bottom.',
          'Private WiFi: fix drag and drop during import.',
          'Private WiFi: show an error when too many keys are imported.',
          'Event WiFi: fix IANA time zones.'
        ]
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.72.3',
    'date': '2026-09-02 15:19',
    'changes': {
      'fr': {
        'features': [],
        'bugfixes': [
          'Gestion du WiFi : sélection d’un seul site à la fois.'
        ]
      },
      'en': {
        'features': [],
        'bugfixes': [
          'WiFi management: restrict site selection to a single site.'
        ]
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.72.0',
    'date': '2026-09-01 11:06',
    'changes': {
      'fr': {
        'features': [
          'Securité : Le compte est bloqué après 5 tentatives de login en échec'
        ],
        'bugfixes': [
          'Supervision : affichage des SSID configurés.'
        ]
      },
      'en': {
        'features': [
          'Security : The account is locked after 5 failed login attempts.'
        ],
        'bugfixes': [
          'Supervision: display configured SSIDs.'
        ]
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.71.4',
    'date': '2026-08-31 11:00',
    'changes': {
      'en': {
        'features': [],
        'bugfixes': [
          'Hyperis: sso',
          'Supervision: equipment count.',
          'Supervision: detailed-view scrolling.'
        ]
      },
      'fr': {
        'features': [],
        'bugfixes': [
          'Hyperis: sso',
          'Supervision : comptage des équipements.',
          'Supervision : défilement de la vue détaillée.'
        ]
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.70.3',
    'date': '2026-08-26 11:06',
    'changes': {
      'en': {
        'features': [],
        'bugfixes': [
          'Project: service renewal for redeployments.',
          'Project: hide missing delivery dates.',
          'Project: document order Audit, technical visit, then DOE.',
          'Project: process statuses displayed as chips.',
          'Supervision: display each building\'s own status.'
        ]
      },
      'fr': {
        'features': [],
        'bugfixes': [
          'Projet : renouvellement de service pour les redéploiements.',
          'Projet : masquage des dates de livraison non renseignées.',
          'Projet : ordre des documents Audit, VT puis DOE.',
          'Projet : statuts des processus affichés en pastilles.',
          'Supervision : affichage du statut propre à chaque bâtiment.'
        ]
      }
    }
  },
  {
    'source': 'GraphQL',
    'version': '2.40.0',
    'date': '2026-08-27 10:42',
    'changes': {
      'en': {
        'features': [
          'Add monitoring data for detailed equipment views.'
        ],
        'bugfixes': []
      },
      'fr': {
        'features': [
          'Ajout des données de supervision pour la vue détaillée des équipements.'
        ],
        'bugfixes': []
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.71.0',
    'date': '2026-08-27 10:42',
    'changes': {
      'en': {
        'features': [
          'Restyle the Equipment tab, add detailed equipment views, and remove the Hyperis tab.'
        ],
        'bugfixes': []
      },
      'fr': {
        'features': [
          'Refonte de l\'onglet Équipements, ajout d\'une vue détaillée et suppression de l\'onglet Hyperis.'
        ],
        'bugfixes': []
      }
    }
  },
  {
    'source': 'GraphQL',
    'version': '2.39.0',
    'date': '2026-08-11 16:30',
    'changes': {
      'en': {
        'features': [
          'Add verbatim, start_at and end_at for export ran'
        ],
        'bugfixes': []
      },
      'fr': {
        'features': [
          'Ajout des filtres verbatim, date de début et date de fin pour les export wifi privé'
        ],
        'bugfixes': []
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.70.0',
    'date': '2026-08-11 16:30',
    'changes': {
      'en': {
        'features': [
          'Add verbatim, start_at and end_at for export ran'
        ],
        'bugfixes': []
      },
      'fr': {
        'features': [
          'Ajout des filtres verbatim, date de début et date de fin pour les export wifi privé'
        ],
        'bugfixes': []
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.69.1',
    'date': '2026-08-11 15:45',
    'changes': {
      'en': {
        'bugfixes': [
          'Reset filters on equipments list'
        ]
      },
      'fr': {
        'bugfixes': [
          'Reinitialisation des filtres dans la vue équipements'
        ]
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.69.0',
    'date': '2026-08-11 15:30',
    'changes': {
      'en': {
        'features': [
          'Add model and manufacturer filter on equipments list'
        ]
      },
      'fr': {
        'features': [
          'Ajout des filtres modèles et fabricants pour la vue des équipements'
        ]
      }
    }
  },
  {
    'source': 'GraphQL',
    'version': '2.38.2',
    'date': '2026-08-06 14:35',
    'changes': {
      'en': {
        'features': [],
        'bugfixes': [
          'Fix equipment labels and parent links in topology.'
        ]
      },
      'fr': {
        'features': [],
        'bugfixes': [
          'Correction des libellés et des parents d\'équipements dans la topologie.'
        ]
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.68.6',
    'date': '2026-08-06 14:30',
    'changes': {
      'en': {
        'features': [],
        'bugfixes': [
          'Improve project header display.',
          'Make detail side panels responsive.'
        ]
      },
      'fr': {
        'features': [],
        'bugfixes': [
          'Amélioration de l\'affichage de l\'en-tête projet.',
          'Adaptation responsive des panneaux de détail.'
        ]
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.68.5',
    'date': '2026-07-30 15:22',
    'changes': {
      'en': {
        'features': [
          'Restyle all tables and detail cards.',
          'Add a tooltip on the TV message action.'
        ],
        'bugfixes': [
          'Hide project marker popups on hover.',
          'Disable topology access when unavailable.',
          'Default unsupported languages to English.',
          'Fix executable report labels.',
          'Fix the duplicate project contact column.',
          'Ignore TVs and Chromecasts in floor status.',
          'Fix sidebar menu item jump.'
        ]
      },
      'fr': {
        'features': [
          'Refonte du style des tables et cartes de détail.',
          'Ajout d\'un tooltip sur l\'action Message TV.'
        ],
        'bugfixes': [
          'Masquage au survol des popups des pins des sites dans l\'onglet Projet.',
          'Désactivation de la redirection vers la topologie si indisponible.',
          'Anglais par défaut si la langue n\'est pas supportée.',
          'Correction du libellé Rapport exécutable.',
          'Correction de la colonne contact projet dupliquée.',
          'Exclusion des TVs et Chromecasts de l\'état étage.',
          'Correction du saut des éléments du menu latéral.'
        ]
      }
    }
  },
  {
    'source': 'GraphQL',
    'version': '2.38.1',
    'date': '2026-07-27 14:31',
    'changes': {
      'en': {
        'features': [
          'Add TV replacement and TV configuration support for Chromecast.'
        ],
        'bugfixes': []
      },
      'fr': {
        'features': [
          'Ajout du support de remplacement TV et de configuration TV pour Chromecast.'
        ],
        'bugfixes': []
      }
    }
  },
  {
    'source': 'GraphQL',
    'version': '2.38.0',
    'date': '2026-07-23 16:10',
    'changes': {
      'en': {
        'features': [],
        'bugfixes': [
          'Add the missing MAC address for Wibox devices.',
          'Remove the site count from contacts exports.'
        ]
      },
      'fr': {
        'features': [],
        'bugfixes': [
          'Ajout de l\'adresse MAC manquante pour les équipements Wibox.',
          'Suppression du nombre de sites dans l\'export contacts.'
        ]
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.68.0',
    'date': '2026-07-23 11:47',
    'changes': {
      'en': {
        'features': [
          'Restyle the menu, header, and breadcrumbs.',
          'Move the Edit TV message action directly into the table, with a light cleanup and improved contrast.',
          'Add a topology link that focuses the equipment, opens its detail panel, and positions the sidebar on the related equipment type.',
          'Show dynamic month/day labels in statistics according to the selected filter.'
        ],
        'bugfixes': [
          'Keep works equipment colors consistent on grouped devices.',
          'Prefill the site when creating a code from a single selected site.'
        ]
      },
      'fr': {
        'features': [
          'Mise à jour du style du menu et refonte de l\'en-tête et du fil d\'Ariane.',
          'Déplacement de l\'action Modifier le message TV dans la vue table avec une amélioration du contraste.',
          'Ajout d\'un lien vers la topologie avec focus sur l\'équipement concerné.',
          'Libellé dynamique par mois / jour selon le filtre choisi dans les statistiques.'
        ],
        'bugfixes': [
          'Correction des couleurs des équipements en travaux dans les groupes.',
          'Préremplissage du site à la création d\'un code lorsqu\'un seul site est sélectionné.'
        ]
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.67.0',
    'date': '2026-07-02 10:55',
    'changes': {
      'en': {
        'features': [
          'Update the heatmap player UI and add a timeline.',
          'Add release notes.'
        ],
        'bugfixes': [
          'Fix master filter tree expand/collapse behavior and UI issues on tree branches.'
        ]
      },
      'fr': {
        'features': [
          'Mise à jour de l\'UI du Heatmap Player et ajout d\'une timeline.',
          'Ajout des notes de version.'
        ],
        'bugfixes': [
          'Correction du dépliage/repliage du filtre principal et de l\'UI des branches.'
        ]
      }
    }
  },
  {
    'source': 'GraphQL',
    'version': '2.37.1',
    'date': '2026-06-25 14:55',
    'changes': {
      'en': {
        'features': [],
        'bugfixes': [
          'Fix count hotspots.'
        ]
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.66.0',
    'date': '2026-06-25 14:22',
    'changes': {
      'fr': {
        'features': [
          'Ajout des équipements Wibox sur la carte indoor.',
          'Suppression du bouton de redirection My Center.'
        ],
        'bugfixes': []
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.65.0',
    'date': '2026-06-25 13:55',
    'changes': {
      'en': {
        'features': [],
        'bugfixes': [
          'Normalize errors.'
        ]
      }
    }
  },
  {
    'source': 'GraphQL',
    'version': '2.37.0',
    'date': '2026-06-25 13:54',
    'changes': {
      'en': {
        'features': [
          'Hotspots only on production.'
        ],
        'bugfixes': [
          'Normalize errors.'
        ]
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.64.1',
    'date': '2026-06-18 16:43',
    'changes': {
      'en': {
        'features': [
          'Remove WAN monitoring state fields.'
        ],
        'bugfixes': []
      }
    }
  },
  {
    'source': 'GraphQL',
    'version': '2.36.1',
    'date': '2026-06-18 16:43',
    'changes': {
      'en': {
        'features': [
          'Remove WAN monitoring state from schema.'
        ],
        'bugfixes': []
      }
    }
  },
  {
    'source': 'Front',
    'version': '1.64.0',
    'date': '2026-06-18 15:31',
    'changes': {
      'en': {
        'features': [
          'Show private WiFi status on code card.',
          'Add supervised AP total to SSID views.',
          'Move EDA and silent mode menus into sidebar scroll.'
        ],
        'bugfixes': [
          'Fix topology equipment icons.'
        ]
      }
    }
  }
]

export default releaseNotesData
